import type {IRepository} from "..";
import type {Action} from "../action/action";
import type {BookingflowStateMachine} from "../bookingflowstatemachine";

export abstract class State<GAction extends Action<string, any>, StateName> {
  public abstract type: StateName;
  public data: any;
  public bookingflowStateMachine: BookingflowStateMachine;

  constructor(bookingflowStateMachine: BookingflowStateMachine) {
    this.bookingflowStateMachine = bookingflowStateMachine;
  }

  /**
   *
   * @param obj - The object expected to go to the next state
   * Is this correct, what I am doing with the generic?
   */
  public abstract doAction(action: GAction): State<any, StateName | string>;

  public abstract getActions(): any[];

  public abstract getData(): any;

  /**
   *
   * @param action - The action that is done in doAction
   *
   * This function will reset any set values, that is dependent on the given action
   */
  public abstract unset(action: GAction): void;

  /**
   * Accessor to the repository which speaks with the datasource
   * Could likely be the API.
   *
   * @returns repo - which fetches data from source
   */
  protected get repo(): IRepository {
    return this.bookingflowStateMachine.repo;
  }
}

export type StateName =
  | "ADDRESS"
  | "BASISTYPE"
  | "CALENDAR"
  | "CHECKOUT"
  | "COMPANY"
  | "COMPANY_PRODUCT_PICK_STATE"
  | "DETAILS"
  | "ERROR_STATE"
  | "MOVEBOOKING"
  | "NOT_AVAILABLE"
  | "PACKAGE"
  | "CANCEL_BOOKING_ADMIN_STATE"
  | "CONFIRM_CANCELLATION_ADMIN_STATE";
